import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { DialogConfig, DialogConfigData } from '@app/common/models/dialog-config';
import { DialogRef } from '@app/common/services/dialog-ref';
import { ComponentModel} from '@app/common/models/component.model';
import * as _ from 'lodash';
import { AttachmentTypeModel } from '@app/common/models/attachment-type.model';
import { AttachmentTypePipe } from '@app/common/pipes/attachment-type.pipe';
import * as GMTCK from 'gmt-ckeditor/dist';
import { DialogService } from '@app/common/services/dialog.service';
import {ClassName} from "@app/common/enums/class-name.enum";

@Component({
  selector: 'component-edit',
  templateUrl: './component-edit.component.html',
  styleUrls: ['./component-edit.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ComponentEditComponent implements OnInit {

  component: ComponentModel;
  attachmentTypes: AttachmentTypeModel[];
  attachmentType: AttachmentTypeModel;
  canEdit;
  canChangeAttachmentType;
  editor;

  constructor(
    private dialogConfig: DialogConfig,
    public dialogComponent: DialogRef,
    public attachmentTypePipe: AttachmentTypePipe,
    private dialogService: DialogService,
  ) {
    this.onUpdate = this.onUpdate.bind(this);
    this.onCancel = this.onCancel.bind(this);
  }

  async ngOnInit() {
    this.canEdit = (<DialogConfigData>this.dialogConfig.data).canEdit;
    const component = (<DialogConfigData>this.dialogConfig.data).component;
    const document = component.document;

    const acquisitionDeeds = AttachmentTypeModel.getByCategory('acquisitionDeed').map(a => a.id);
    let canChangeDetail = true;
    let attachmentTypes = _.cloneDeep(AttachmentTypeModel.getByCategory('component'))
      .filter(a => !a.labels.includes('acquisitionDeed'))
      .filter(a => !['CONTRACT_EXTERNAL', 'COVERING_LETTER_EXTERNAL'].includes(a.id));

    if (document.businessCase) {
      canChangeDetail = !document.businessCase.heliosImportStatus || !acquisitionDeeds.includes(component.attachmentType);
      attachmentTypes = _.cloneDeep(AttachmentTypeModel.getByCategory('component'))
        .filter(a => !['OPINION_SCAN_EXTERNAL', 'GEOMETRIC_PLAN_EXTERNAL'].includes(a.id));

      if (component.sourceType === 'MPV_INSERTED') {
        attachmentTypes = attachmentTypes.filter(a => !a.labels.includes('acquisitionDeed'));
      }
    } else if (document.opinionRequest) {
      attachmentTypes = attachmentTypes.filter(a => !['GEOMETRIC_PLAN_EXTERNAL'].includes(a.id));
    } else if (document.geometricPlanRequest) {
      attachmentTypes = attachmentTypes.filter(a => !['OPINION_SCAN_EXTERNAL'].includes(a.id));
    } else if (!component.document.classified) {
      attachmentTypes = _.cloneDeep(AttachmentTypeModel.getByCategory('component'))
        .filter(a => !['CONTRACT_EXTERNAL', 'COVERING_LETTER_EXTERNAL'].includes(a.id));
    } else {
      attachmentTypes = attachmentTypes.filter(a => !['GEOMETRIC_PLAN_EXTERNAL', 'OPINION_SCAN_EXTERNAL'].includes(a.id));
    }

    this.component = component;
    this.canChangeAttachmentType = (component.sourceType === 'EPD' || component.sourceType === 'MPV_INSERTED') && canChangeDetail;
    this.attachmentTypes = attachmentTypes;
    this.attachmentType = this.component.attachmentType ? AttachmentTypeModel.createById(this.component.attachmentType) : undefined;
    await this.prepareEditor();
  }

  isValid() {
    return this.attachmentType;
  }

  onUpdate() {
    this.component.note = this.editor.getData();
    this.component.attachmentType = this.attachmentType ? this.attachmentType.id : undefined;
    this.dialogComponent.close(this.component);
  }

  onCancel() {
    this.dialogComponent.close(false);
  }

  private async prepareEditor() {
    if (this.component.note === undefined) {
      this.component.note = '';
    }
    this.editor = await GMTCK.ClassicEditor.create(document.querySelector('#editor'));
    this.editor.setData(this.component.note);
  }
}
